import { Text } from "@clipboard-health/ui-react";
import { isDefined } from "@clipboard-health/util-ts";
import { alpha, Card, CardActions, CardContent, Stack } from "@mui/material";
import { type ReactNode } from "react";

interface ChatWidgetCardProps {
  title: string;
  subtitle: string;
  caption?: string;
  statusChip: ReactNode;
  actions?: ReactNode;
}

export function ChatWidgetCard(props: ChatWidgetCardProps) {
  const { title, subtitle, caption, statusChip, actions } = props;

  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        border: "1px solid",
        borderColor: alpha(theme.palette.secondary.main, 0.4),
        width: "400px",
        borderRadius: "24px 24px 4px 24px",
      })}
    >
      <CardContent>
        <Stack direction="row" alignItems="flex-start" gap={2}>
          <Stack sx={{ marginRight: "auto" }}>
            <Text bold variant="subtitle1" sx={{ color: (theme) => theme.palette.primary.main }}>
              {title}
            </Text>
            <Text variant="body2" sx={{ color: (theme) => theme.palette.primary.main }}>
              {subtitle}
            </Text>
            {isDefined(caption) && (
              <Text variant="caption" color="text.secondary">
                {caption}
              </Text>
            )}
          </Stack>

          {statusChip}
        </Stack>
      </CardContent>

      {actions && (
        <CardActions sx={{ paddingX: 2, paddingTop: 0, paddingBottom: 2 }}>{actions}</CardActions>
      )}
    </Card>
  );
}
